/** Marketplace API — Faz 1.4 createApi factory. */
import {createApi} from './_factory'
import type {CommonNs} from '@shared/types'
import type {MarketNs} from '@shared/types/marketplace.namespace'

const api = createApi('marketplace')

export const MarketApi = {
  importProject: (data: MarketNs.ImportProjectRequest) =>
    api.post<MarketNs.ImportProjectRequest, CommonNs.AnyResponse>('import-project', data),
}
